module.exports = __webpack_public_path__ + "static/media/Loading.7bba69d0.svg";